import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
    Typography,
    AppBar,
    Toolbar,
    Link,
    CardActionArea,
    TextField,
    Button,
    Paper,
    FormControlLabel,
    Checkbox, ButtonGroup
} from "@material-ui/core";
import {
    Grid,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    LinearProgress,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemSecondaryAction,
    Switch,
    Divider,
    Avatar,
    Chip,
    IconButton,
    Tooltip, Popover
} from "@material-ui/core";
import {
    DesktopMac,
    Add,
    FilterList,
    AccountBalance,
    ArrowForwardIos,
    CheckCircle,
    Group,
    Block,
    AccountCircle,
    Close,
    Edit,
    Delete,
    Assignment,
    VpnLock,
    Money,
    Schedule,
    CallMade,
    CallReceived,
    Business,
    AcUnit, DateRange
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";
import Format from "date-fns/format";

import { makeStyles } from "@material-ui/styles";
import { Skeleton } from "@material-ui/lab";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { useSnackbar } from "notistack";

import {
    FinanceService,
    AdminService,
    Validator,
} from "../../../../../utils/web_config";
import {
    useAccountTypes,
    useGetOrganization,
} from "../../../hooks/use_hooks";
const axios = require("axios");

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            marginLeft: 250,
        },
    },
    title: {
        flexGrow: 1,
    },
    btn: {
        textTransform: "capitalize",
    },
    btn2: {
        textTransform: "capitalize",
        border: "dashed grey 1px",
    },
    paper: {
        padding: 15,
    },
    action: {
        borderRadius: 15,
    },
}));

function PosAgents(props) {
    const classes = useStyles();
    const history = useHistory();

    const organization = useGetOrganization({
        id: history.location.state?.organization_id,
    });
    const [accountData, setAccountData] = useState({});

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedAccount, setSelectedAccount] = useState({
        saving: false,
        loading: false,
        toggling: false,
        data: {},
    });

    const [from, setFrom] = useState({
        value: new Date(),
        error: "",
    });
    const [to, setTo] = useState({
        value: new Date(),
        error: "",
    });
    const [range, setRange] = useState({ index: 0, acnhor: null });



    const [userAccount, setUserAccount] = useState({
        saving: false,
        loading: false,
        data: {},
    });

    const [agents, setAgents] = useState({
        page: 0,
        count: 1,
        rowsPerPage: 10,
        sortOrder: {},
        status: "Loading POS Agents....",
        loading: false,
        toggling: false,
        data: [],
    });

    useEffect(() => {
        var accountData = new AdminService().accountData;
        setAccountData(accountData);

        setSelectedAccount({
            ...selectedAccount,
            data: history.location.state,
        });
        getAccountDetails(accountData.token, history.location.state.account_number);
        getAgents(accountData.token, history.location.state.code) ;
    }, []);

    ///////////////////////////////////
    //////////
    const agentsColums = [
        {
            name: "username",
            label: "Username",
            options: {
                filter: true,
                sort: false,
            },
        },
        {
            name: "first_name",
            label: "First Name",
            options: {
                filter: true,
                sort: false,
            },
        },
        {
            name: "last_name",
            label: "Last Name",
            options: {
                filter: true,
                sort: false,
            },
        },
        
        {
            name: "phone_number",
            label: "Phone Number",
            options: {
                filter: false,
                sort: false
            },
        }
    ];

    const agentsOptions = {
        filterType: "multiselect",
        elevation: 0,
        selectableRows: "none",
        searchPlaceholder: "Search POS Agent...",
        selectableRowsOnClick: true,
        fixedHeader: true,
        searchProps: {
            variant: "outlined",
            margin: "dense",
        },
        textLabels: {
            body: {
                noMatch: agents.status,
            },
        },
    };
    /////////////////////
    const notify = (variant, msg, status) => {
        if (status == 401) {
            history.push("/", { expired: true });
        }
        enqueueSnackbar(msg, {
            variant: variant,
            action: (k) => (
                <IconButton
                    onClick={() => {
                        closeSnackbar(k);
                    }}
                    size="small"
                >
                    <Close fontSize="small" />
                </IconButton>
            ),
        });
    };

   

    const capitalize = (s) => {
        return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    };
    /////////////////////////////////////////////////

    const getAccountDetails = (token, acc) => {
        const agentsInstance = axios.create(new AdminService().getHeaders(token));

        setUserAccount({ ...userAccount, loading: true });

        console.log("getting account .....");

        agentsInstance
            .get(new FinanceService().GET_ACCOUNT_PROFILE + acc)
            .then(function (response) {
                const d = response.data;
                setUserAccount({ ...userAccount, loading: false, data: d.data });
            })
            .catch(function (error) {
                setUserAccount({ ...userAccount, loading: false });
                var e = error.message;

                if (error.response) {
                    e = error.response.data.message;
                }
                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };

    ///////////////////////////////////

    const getAgents = (token,code) => {
        const usersInstance = axios.create(new AdminService().getHeaders(token));

        setAgents({ ...agents, loading: true });

        console.log("getting agents .....");

        usersInstance
            .get(
                new FinanceService().GET_POS_AGENTS + code
            )
            .then(function (response) {
                setAgents({ ...agents, loading: false });

                const d = response.data;

                if (d.data.length == 0) {
                    setAgents({
                        ...agents,
                        status: "There are no agents available",
                    });
                } else {
                    var groups = new Validator().groupArrayOfObjects(
                        d.data,
                        "tx_type_name"
                    );
                    var keys = Object.keys(groups);
                    setAgents({
                        ...agents,
                        data: d.data,
                        allData: d.data,
                        keys: keys,
                        groups: groups,
                    });
                }
            })
            .catch(function (error) {
                setAgents({ ...agents, loading: false });

                var e = error.message;

                if (error.response) {
                    e = error.response.data.message;
                }
                setAgents({ ...agents, status: e });

                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };

    //////////////////////////////////////
    const toggleAccount = () => {
        const agInstance = axios.create(
            new AdminService().getHeaders(accountData.token)
        );

        setSelectedAccount({ ...selectedAccount, toggling: true });

        console.log("toggling acc.....");

        const account = selectedAccount.data;
        var url;
        if (account.status == "ENABLED") {
            url = new FinanceService().DISABLE_ACCOUNT + account.account_number;
            account["status"] = "DISABLED";
        } else {
            url = new FinanceService().ENABLE_ACCOUNT + account.account_number;
            account["status"] = "ENABLED";
        }

        setSelectedAccount({ ...selectedAccount, data: account });

        agInstance
            .put(url)
            .then(function (response) {
                const d = response.data;
                setSelectedAccount({
                    ...selectedAccount,
                    data: d.data,
                    toggling: false,
                });

                notify("success", d.message);
            })
            .catch(function (error) {
                account["status"] =
                    account.status == "ENABLED" ? "DISABLED" : "ENABLED";
                var e = error.message;

                setSelectedAccount({
                    ...selectedAccount,
                    data: account,
                    toggling: false,
                });

                if (error.response) {
                    e = error.response.data.message;
                }
                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };


    /// start load service fee ///

    const [openServiceFee, setOpenServiceFee] = useState(false);
    const [reference, setReference] = useState({ value: "", error: "" });
    const [amount, setAmount] = useState({ value: 0, error: "" });
    const [serviceFeeLoad, setServiceFeeLoad] = useState(false);
    const load_service_fee = () => {
        setServiceFeeLoad(true)
        const serviceFeeInstance = axios.create(new AdminService().getHeaders(accountData.token));
        const data = {
            channel_type: "WEB",
            agent_code: selectedAccount.data.code,
            reference_number: reference.value,
            amount: amount.value
        }

        serviceFeeInstance
            .post(new FinanceService().AGENT_ACCOUNT_TOPUP, data)
            .then(function (response) {
                setServiceFeeLoad(false)
                setOpenServiceFee(false)
                notify("success", "Service fee credited successfully!", 200);
                getAccountDetails(accountData.token, selectedAccount.data.account_number);
            })
            .catch(function (error) {
                setServiceFeeLoad(false)
                var e = error.message;
                if (error.response) {
                    e = error.response.data.message;
                }
                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    }
    /// end load service fee /// 

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className={classes.root}>
              


                <Box display="flex" alignItems="center">
                    <Box mr={2}>
                        {" "}
                        <AccountBalance color="primary" fontSize="large" />
                    </Box>
                    <Box flexGrow={1} display="flex" alignItems="center">
                        <Typography variant="h5">
                            <b>{selectedAccount.data.account_name}</b>
                        </Typography>
                    </Box>
                </Box>

                <Box mt={3} />
                <Grid container spacing={2}>
                    {/* <Grid item xs={12} lg={4}>

                        <List>
                            {userAccount.loading ? (
                                [1, 2, 3, 4, 5].map((item, i) => (
                                    <ListItem key={i}>
                                        <ListItemText
                                            primary={
                                                <Skeleton
                                                    variant="text"
                                                    width={"100%"}
                                                    style={{ borderRadius: 7 }}
                                                />
                                            }
                                        />
                                    </ListItem>
                                ))
                            ) : (

                                <>
                                    <ListItem>
                                        <ListItemText
                                            primary="Account name"
                                            secondary={selectedAccount.data.account_name}
                                        />
                                        <ListItemSecondaryAction>
                                            <Typography color='primary'><b>{selectedAccount.data.maturity_type}</b></Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText
                                            primary={
                                                selectedAccount.data.device_id != null
                                                    ? "Device ID"
                                                    : "Phone number"
                                            }
                                            secondary={selectedAccount.data.phone_number}
                                        />
                                    </ListItem>
                                    {selectedAccount.data.wallet_id != null && (
                                        <><ListItem>
                                            <ListItemText
                                                primary="Wallet ID(Transport)"
                                                secondary={selectedAccount.data.wallet_id}
                                            />
                                        </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Serial number(XH Wallet)"
                                                    secondary={selectedAccount.data.serial_number ?? 'None'}
                                                />
                                            </ListItem>
                                        </>
                                    )}

                                    <Divider variant="middle" />
                                    <ListItem>
                                        <ListItemIcon>
                                            <AccountCircle />
                                        </ListItemIcon>
                                        <ListItemText primary="Account number:" />
                                        <ListItemSecondaryAction>
                                            <Typography variant="subtitle1" color="textSecondary">
                                                {userAccount.data.account_number_formatted}
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>

                                    <ListItem>
                                        <ListItemIcon>
                                            <Schedule />
                                        </ListItemIcon>
                                        <ListItemText primary="Wallet activation:" />
                                        <ListItemSecondaryAction>
                                            <Typography variant="subtitle1" color="textSecondary">
                                                {userAccount.data.activation_date}
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <Money />
                                        </ListItemIcon>
                                        <ListItemText primary="Opening balance:" />
                                        <ListItemSecondaryAction>
                                            <Typography color="secondary">
                                                <b>
                                                    {new Validator().formatMoney(
                                                        userAccount.data.opening_balance
                                                    )}
                                                    {userAccount.data.currency_code}
                                                </b>
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <AccountBalance />
                                        </ListItemIcon>
                                        <ListItemText primary="Current balance:" />
                                        <ListItemSecondaryAction>
                                            <Typography color="primary">
                                                <b>
                                                    {new Validator().formatMoney(
                                                        userAccount.data.current_balance
                                                    )}
                                                    {userAccount.data.currency_code}
                                                </b>
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <Money />
                                        </ListItemIcon>
                                        <ListItemText primary="Closing balance:" />
                                        <ListItemSecondaryAction>
                                            <Typography color="secondary">
                                                <b>
                                                    {new Validator().formatMoney(
                                                        userAccount.data.reserved_amount
                                                    )}
                                                    {userAccount.data.currency_code}
                                                </b>
                                            </Typography>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <VpnLock />
                                        </ListItemIcon>
                                        <ListItemText primary="Account status:" />
                                        <ListItemSecondaryAction>
                                            <Switch
                                                color="primary"
                                                disabled={selectedAccount.toggling}
                                                value={selectedAccount.data.status}
                                                checked={selectedAccount.data.status == "ENABLED"}
                                                onChange={toggleAccount}
                                            />
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <ListItem>
                                        {userAccount.data.account_type_id == 8 &&
                                            <Button
                                                startIcon={<Money />}
                                                variant="outlined" color="primary" onClick={() => {
                                                    setOpenServiceFee(true)
                                                }}>
                                                {capitalize("Load Service Fee")}
                                            </Button>
                                        }

                                    </ListItem>


                                    <>
                                        {organization.status == "error" ||
                                            organization.status == "empty" ? (
                                            <Box p={5} display="flex" justifyContent="center">
                                                {organization.status == "error" ? (
                                                    <Typography>
                                                        Error loading organization, try to refresh
                                                    </Typography>
                                                ) : (
                                                    <Typography>
                                                        There are no organization available for this account.
                                                    </Typography>
                                                )}
                                            </Box>
                                        ) : (
                                            <List>
                                                {organization.status != "loading" ? (
                                                    <>
                                                        <Divider variant="middle" />

                                                        <ListItem>
                                                            <ListItemIcon>
                                                                <Business />
                                                            </ListItemIcon>
                                                            <ListItemText primary="Organization info" />
                                                        </ListItem>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary="Organization"
                                                                secondary={organization.data.name}
                                                            />
                                                        </ListItem>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary="Organization type:"
                                                                secondary={organization.data.organization_type}
                                                            />
                                                        </ListItem>
                                                    </>
                                                ) : (
                                                    Array.from(Array(3).keys()).map((item, i) => (
                                                        <ListItem key={i}>
                                                            <ListItemText
                                                                primary={
                                                                    <Skeleton
                                                                        variant="text"
                                                                        width={"100%"}
                                                                        style={{ borderRadius: 7 }}
                                                                    />
                                                                }
                                                            />
                                                        </ListItem>
                                                    ))
                                                )}


                                            </List>


                                        )}
                                    </>
                                </>
                            )}
                        </List>
                    </Grid> */}
                    <Grid item xs={12} lg={12}>
                        <Box mt={2} />
                        {agents.loading && <LinearProgress />}
                        <MUIDataTable
                            title={"POS Agents"}
                            data={agents.data}
                            columns={agentsColums}
                            options={agentsOptions}
                        />
                    </Grid>
                </Grid>
            </div>

            {/* start of dialog for service fee load */}
            <Dialog
                open={openServiceFee}
                onClose={() => setOpenServiceFee(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">{"Service Fee Topup"}</DialogTitle>
                <DialogContent>
                    <Box>
                        <Box mt={1}>
                            <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                placeholder={"Reference"}
                                label={"Reference"}
                                fullWidth
                                onChange={(e) => {
                                    if (e.target.value == "") {
                                        setReference({ value: "", error: "Invalid reference number" });
                                    } else {
                                        setReference({ value: e.target.value, error: "" });
                                    }
                                }}
                                helperText={reference.error}
                                error={reference.error !== ""}
                            />
                        </Box>
                        <Box mt={1}>
                            <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                placeholder={"Amount"}
                                label={"Amount"}
                                fullWidth
                                type="number"
                                onChange={(e) => {
                                    if (e.target.value == 0) {
                                        setAmount({ value: "", error: "Invalid Amount" });
                                    } else {
                                        setAmount({ value: e.target.value, error: "" });
                                    }
                                }}
                                helperText={amount.error}
                                error={amount.error !== ""}
                            />
                        </Box>
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button elevation={0} disable={serviceFeeLoad} onClick={() => load_service_fee()} variant="contained" color="primary">
                        Credit
                    </Button>
                    <Button variant="outlined" onClick={() => setOpenServiceFee(false)} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* end of dialog for service fee load */}
        </MuiPickersUtilsProvider>
    );
}

export default withLocalize(PosAgents);
